// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"RecommendButton_buttonWrapper__3L8U-","isLiked":"RecommendButton_isLiked__2tNXk","recommend-text":"RecommendButton_recommend-text__mOBZs"};